module.exports = __webpack_public_path__ + "static/loans-8381bd3132e8b634d880253c4451f400.png";